import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"

export const ArrowRight = (props) => {
  return <FontAwesomeIcon faIcon={faArrowRight} {...props} />
}
